// Copy constants for UX flow rewrite

export const COPY = {
  // Upload screen (logged-out state)
  UPLOAD_LOGGED_OUT_HEADLINE: 'Try SafeVibe in 10 seconds — no signup required',
  UPLOAD_LOGGED_OUT_OVERLAY: 'Create free account to scan your own code.',
  UPLOAD_LOGGED_OUT_SECONDARY: 'Unlock uploads after quick signup.',
  UPLOAD_DEMO_BUTTON: 'Run demo scan now',
  
  // Demo results screen
  DEMO_RESULTS_BANNER: "You're viewing a sample report. Sign up to secure your own code.",
  DEMO_RESULTS_CTA_HEADER: 'Ready to Scan Your Real Codebase?',
  DEMO_RESULTS_CTA_DESCRIPTION: 'This demo shows you what SafeVibe can find in your code. Upload your own project or connect your GitHub repository to get a real security analysis.',
  
  // Credits exhausted
  CREDITS_EXHAUSTED_TITLE: 'Out of free scans',
  CREDITS_EXHAUSTED_MESSAGE: 'Out of free scans – upgrade for unlimited security checks.',
  
  // Signup modal
  SIGNUP_MODAL_TITLE: 'Create Your Free Account',
  SIGNUP_MODAL_BENEFITS: [
    '10 free scans',
    'AI-powered insights', 
    'No credit card'
  ],
}; 